// extracted by mini-css-extract-plugin
export default {"container":"TabGroup_container__wKyoA","sticky":"TabGroup_sticky__ogqbz"};